import React from 'react';

const TextBlock = ({ block }) => {
  if (!block.text) return null;

  let formattedText = block.text;
  
  if (block.formatting) {
   
    if (block.formatting.bold) {
      if (Array.isArray(block.formatting.bold)) {
      
        const sortedWords = [...block.formatting.bold].sort((a, b) => b.length - a.length);
        sortedWords.forEach(word => {
    
          const escapedWord = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
         
          const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(word);
          const regex = isAlphanumeric 
            ? new RegExp(`\\b(${escapedWord})\\b`, 'g')
            : new RegExp(`(${escapedWord})`, 'g');
          formattedText = formattedText.replace(regex, `<strong>$1</strong>`);
        });
      } else if (Array.isArray(block.formatting.bold) && block.formatting.bold.length > 0 && typeof block.formatting.bold[0] === 'object') {
       
        block.formatting.bold.forEach(({ start, end }) => {
          const before = formattedText.substring(0, start);
          const boldText = formattedText.substring(start, end);
          const after = formattedText.substring(end);
          formattedText = `${before}<strong>${boldText}</strong>${after}`;
        });
      }
    }
  }

  return (
    <div className="mb-4 text-gray-700 leading-relaxed">
      <p dangerouslySetInnerHTML={{ __html: formattedText }} />
    </div>
  );
};

export default TextBlock;

